export default {
  BORDER: {
    color: '#000000',
  },
  OCEAN: {
    color: '#276BAC',
  },
  BEACH: {
    color: 'rgb(247,240,216)',
  },
  FOREST: {
    color: '#4B720E',
  },
  JUNGLE: {
    color: '#1F824E',
  },
  SAVANNAH: {
    color: '#7B720E',
  },
  DESERT: {
    color: '#F0E19D',
  },
  SNOW: {
    color: '#FFFAFA',
  },
  SCORCHED: {
    color: 'rgb(229,212,180)',
  },
  BARE: {
    color: 'rgb(182,160,125)',
  },
  TUNDRA: {
    color: '#74883C',
  },
  SHRUBLAND: {
    color: 'rgb(114,160,63)',
  },
  TAIGA: {
    color: 'rgb(45,74,47)',
  },
  TEMPERATE_DESERT: {
    color: 'rgb(211,200,97)',
  },
  TEMPERATE_DECIDUOUS_FOREST: {
    color: 'rgb(70,100,47)',
  },
  TEMPERATE_RAIN_FOREST: {
    color: 'rgb(50,130,80)',
  },
  SUBTROPICAL_DESERT: {
    color: 'rgb(180,200,150)',
  },
  GRASSLAND: {
    color: 'rgb(220,210,140)',
  },
  TROPICAL_SEASONAL_FOREST: {
    color: 'rgb(90,140,60)',
  },
  TROPICAL_RAIN_FOREST: {
    color: 'rgb(0,140,60)',
  },
}
